(ns bec-core.cljs.components.logo)

(defn app-logo [& [props]]
  [:img
   (merge
     props
     {:src "favicon/android-chrome-512x512.png"})])